import { render, staticRenderFns } from "./CountryRiskDialog.vue?vue&type=template&id=4794838c&"
import script from "./CountryRiskDialog.vue?vue&type=script&lang=js&"
export * from "./CountryRiskDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports